import axiosInstance from '@/libs/axios_config'

export interface BankAccountPayload {
  address: string
  address_2?: string
  city: string
  zip_code: string
  global_state_id: number
  account_number: string
  routing_number: string
  bank_name: string
  account_holder_name: string
  account_holder_dob: string
  account_type_id: number
  account_nickname: string
  verification_status_id: number
}

export const POSTBankAccount = async (payload: BankAccountPayload) => {
  const response = await axiosInstance.post('/scholar/bank_accounts', payload)
  return response.data
}

export const GETBankAccount = async () => {
  const response = await axiosInstance.get(`/bank_accounts`)
  return response.data
}

export const DELETEBankAccount = async () => {
  const response = await axiosInstance.delete(`/bank_accounts`)
  return response.data
}